import { render, staticRenderFns } from "./EditCategoryDialog.vue?vue&type=template&id=001c4b16"
import script from "./EditCategoryDialog.vue?vue&type=script&lang=js"
export * from "./EditCategoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports